// The server HTML keeps each component's readable copy for agents without JavaScript; once the
// component is defined, the rendered page carries the content once, see ADR 0013.
export function removeReadableCopies(root: ParentNode = document): void {
  root.querySelectorAll('[slot="readable"]').forEach((readable) => {
    const host = readable.parentElement;
    if (!host) {
      return;
    }
    customElements.whenDefined(host.localName).then(() => readable.remove());
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => removeReadableCopies(), { once: true });
} else {
  removeReadableCopies();
}
